<template>
  <FreePageLayout>
    <template #header>
      <FreeHeader class="p-4" is-centered>
        <template #leftAction>
          <FreeBackButton @click="onAncillariesSave" />
        </template>
        <template #default>
          <h2
            class="text-text-neutral-primary text-center text-lg font-semibold"
          >
            {{ $t('ancillaries.baggages.title') }}
          </h2>
        </template>
        <template #rightAction>
          <FriendsLabel
            v-if="freedomFriendsSelfInfo.data.value?.active"
            class="relative"
            is-short
            is-baggage
          />
        </template>
      </FreeHeader>
    </template>
    <template #default>
      <div class="flex-grow space-y-3 pb-4">
        <div
          v-for="passenger in passengersWithBaggages.currentState.value"
          :key="passenger.id"
          class="bg-background-neutral-secondary w-full rounded-2xl px-4"
        >
          <h2
            v-if="passengersWithBaggages.currentState.value.length > 1"
            class="text-text-neutral-primary pt-3 text-lg font-semibold"
          >
            {{ `${passenger.lastName} ${passenger.firstName}` }}
          </h2>
          <div class="divide-situational-lightgrey divide-y">
            <FlightBaggage
              v-for="(flight, idx) in passenger.flightsWithBaggages"
              :key="flight.id"
              :is-back-segment="flight.id !== 0"
              :flight-direction="`${flight.dep} — ${flight.arr}`"
              :baggages="flight.availableBaggages"
              :flight-idx="idx"
              @onBaggagesUpdate="
                passengersWithBaggages.onUpdate(
                  passenger.key,
                  flight.id,
                  $event,
                )
              "
            />
          </div>
        </div>
      </div>
      <TotalPrice
        v-if="passengersWithBaggages.totalPrice.value"
        :total-price="passengersWithBaggages.totalPrice.value"
        :total-original-price="passengersWithBaggages.totalOriginalPrice.value"
        @onAncillariesSave="onAncillariesSave"
      />
      <FreeButton
        v-else
        type="button"
        class="green-main-button sticky bottom-4 mt-4"
        @click="onAncillariesSave"
      >
        {{ $t('general.back') }}
      </FreeButton>
    </template>
  </FreePageLayout>
</template>

<script setup lang="ts">
  import { useRouter } from 'vue-router';
  import {
    FreePageLayout,
    FreeBackButton,
    FreeHeader,
    FreeButton,
  } from 'freedom-shared';

  import {
    FlightBaggage,
    ancillaryBaggageModel,
  } from '@/widgets/ancillary-baggage';

  import { FriendsLabel, useFreedomFriendsSelfInfo } from '@/features/friends';

  import { mappedPassengersLib } from '@/entities/passenger-with-baggages';

  import { sentryModel } from '@/shared/model';

  import { TotalPrice } from './ui';
  import { ancillariesModel } from './model';

  const router = useRouter();

  const ancillariesStore = ancillaryBaggageModel.useAncillariesStore();
  const passengersWithBaggages = ancillariesModel.useDraftPassengers(
    ancillariesStore.passengersWithBaggage.data?.passengers || [],
  );
  const freedomFriendsSelfInfo = useFreedomFriendsSelfInfo();

  const onAncillariesSave = () => {
    const newPassengersState = passengersWithBaggages.currentState.value;

    newPassengersState.forEach(passenger => {
      ancillariesStore.ancillaries?.onUpdate(
        mappedPassengersLib.getBaggagesPayload(passenger),
      );
    });

    ancillariesStore.passengersWithBaggage.updateState({
      passengers: newPassengersState,
      hasSelectedBaggage: passengersWithBaggages.totalPrice.value > 0,
    });

    sentryModel.addBreadcrumb({
      category: sentryModel.breadcrumbCategories.BOOKING,
      message: 'ancillary baggage updated',
      level: sentryModel.level.INFO,
    });

    router.back();
  };
</script>
